import { Box } from "@mui/material"
import { ProductModal } from "./ProductModal"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { CategoryData, ProductData } from "../../types";
import { useAuth } from "../../assets/contexts/AuthContext";

interface EditProductProps {
  refetchProducts: () => void;
  categories: CategoryData[];
}

export const EditProduct = ({ refetchProducts, categories }: EditProductProps) => {
  const { product_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { fetchData } = useAPI();
  const [product, setProduct] = useState<ProductData>({});
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();

  const handleClose = () => {
    setOpen(false);
    navigate('/products');
  }

  const handleSave = () => {
    navigate('/products');
    refetchProducts();
  }
  
  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/products/${product_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setProduct(data);
        setOpen(true);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [isAuthenticated, product_id]);

  return (
    <Box className="edit-product">
      <ProductModal open={open} handleClose={handleClose} handleSave={handleSave} product={product} categories={categories} />
    </Box>
  )
}